import { FC, useMemo } from "react";
import "./plan-selector.scss";
import { PlanSelectorEnum } from "../shop-management/shop-management";
import { Chip } from "primereact/chip";
import { useDispatch } from "react-redux";
import { changeShopPlan, setShopToChangePlan, setShopToEdit } from "../../shopSlices";
import ProductLogo from "assets/side-bar/product.svg"
import LightningLogo from "assets/side-bar/lightning.svg"
interface PlanSelectorProps {
    title: string;
    description: string;
    price: string;
    details: string[];
    selected: string;
    setSelected: Function;
    setStep: Function;
    shopToChangePlan?: any;
}

const PlanSelector:FC<PlanSelectorProps> = ({title, description, price, details, selected, setSelected, setStep, shopToChangePlan}) => {
    const dispatch: Function = useDispatch();
    const isPro = title === PlanSelectorEnum.PRO;
    const contentBackground = isPro ? "popular-background" : "";
    const contentBorder = isPro? "popular-border" : "";
    const chipVisible = isPro ? "visible" : "";

    const buttonText = useMemo(() => {
        if(title === PlanSelectorEnum.STANDARD && selected === PlanSelectorEnum.STANDARD) {
            return "Your plan";
        }
        if(title === PlanSelectorEnum.STANDARD && selected === PlanSelectorEnum.PRO) {
            return "Downgrade";
        }
        if(title === PlanSelectorEnum.PRO && selected === PlanSelectorEnum.STANDARD) {
            return "Upgrade";
        }
        if(title === PlanSelectorEnum.PRO && selected === PlanSelectorEnum.PRO) {
            return "Your plan";
        }
        return "Get started";
    }, [title, selected]);

    const handleClick = () => {
        if(!selected) {
            setSelected(title);
        } else {
            dispatch(changeShopPlan(shopToChangePlan.id, title));
            dispatch(setShopToChangePlan(null));
            setSelected(null);
        }
        
    }
    return (
        <div className={`plan-selector ${contentBorder}`}>
            <div className="plan-selector__content">
                <div className="plan-selector__content__header">
                    <div className="plan-selector__content__header__icon">
                        <img src={isPro ? LightningLogo : ProductLogo} width={isPro ? 40 : 20} height={isPro ? 40 : 20} alt="plan-icon" />
                    </div>
                    <Chip label={'Most popular'} className={`plan-selector__content__header__chip ${chipVisible}`} />
                </div>
                <div className="plan-selector__content__title">{title}</div>
                <div className="plan-selector__content__description">{description}</div>
                <div className="plan-selector__content__price">
                    <div className="plan-selector__content__price__number">{price}€</div>
                    <div className="plan-selector__content__price__month">/month</div>
                </div>
                <div className="plan-selector__content__separator"></div>
                <div className="plan-selector__content__details">
                    {details.map((detail, index) => <div key={index} className="plan-selector__content__details__detail">{detail}</div>)}
                </div>
                <div className="plan-selector__content__separator"></div>
                <div className={`plan-selector__content__button ${contentBackground}`} onClick={() => {handleClick()}}>{buttonText}</div>
            </div>
        </div>
    );
};

export default PlanSelector;
